export default "__VITE_ASSET__f061a1bb__"